import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Heatmap panel art: nine treemap tiles of mixed size, each green or red at a
 * different alpha so the block reads as a market map.
 *
 * Deliberately no clipPath for the rounded outer shape: a clipPath needs an id,
 * and ids in a set of thirteen inline illustrations are a collision waiting to
 * happen. Each tile carries its own small corner radius instead.
 */

/** [x, y, width, height, fill] */
const TILES: [number, number, number, number, string][] = [
  [12, 12, 60, 44, 'hsl(var(--positive) / 0.55)'],
  [12, 58, 28, 30, 'hsl(var(--negative) / 0.4)'],
  [42, 58, 30, 30, 'hsl(var(--positive) / 0.3)'],
  [74, 12, 40, 26, 'hsl(var(--positive) / 0.7)'],
  [116, 12, 32, 26, 'hsl(var(--negative) / 0.6)'],
  [74, 40, 32, 20, 'hsl(var(--negative) / 0.25)'],
  [108, 40, 40, 20, 'hsl(var(--positive) / 0.45)'],
  [74, 62, 46, 26, 'hsl(var(--positive) / 0.35)'],
  [122, 62, 26, 26, 'hsl(var(--negative) / 0.5)'],
]

export function SectorHeatmapArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {TILES.map(([x, y, width, height, fill]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={width} height={height} rx={2} fill={fill} />
      ))}
    </svg>
  )
}
